import { useQuery } from "@tanstack/react-query";
import { API_GUIDE } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetGuide = <T>(params?: { [key: string]: string }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_GUIDE_INFO, params],
        queryFn: () => API_GUIDE.getGuideInfo<T>(params),
    });

    return { data, isLoading };
};
